<template>
  <div class="menu-wrapper">
    <img :src="require('@/assets/images/logo.png')" alt=""  style="width:176px;margin-top:10px;"/>
     <!-- <div class="title">法证链科技管理平台</div> -->
    <template v-for="item in routes" v-if="!item.hidden && item.children">
      <router-link
        v-if="
          hasOneShowingChildren(item.children) &&
          !item.children[0].children &&
          !item.alwaysShow
        "
        :to="item.path + '/' + item.children[0].path"
        :key="item.children[0].name"
      >
        <el-menu-item
          :index="item.path + '/' + item.children[0].path"
          :class="{ 'submenu-title-noDropdown': !isNest }"
        >
          <svg-icon
            v-if="item.children[0].meta && item.children[0].meta.icon"
            :icon-class="item.children[0].meta.icon"
          ></svg-icon>
          <div
            v-if="item.children[0].meta && item.children[0].meta.title"
            slot="title"
            style="display: inline"
          >
          <span v-if="item.name=='traceBatchExamine'">
            <el-badge v-if="badgeValue>0" :value="badgeValue" class="item">
              <span>{{ item.children[0].meta.title}}</span>
            </el-badge>
            <span v-else>{{ item.children[0].meta.title }}</span>
          </span>
          <span v-else-if="item.name =='PlatForm'">
            <el-badge v-if="platValue>0" :value="platValue" class="item">
              <span>{{ item.children[0].meta.title}}</span>
            </el-badge>
              <span v-else>{{ item.children[0].meta.title}}</span>
          </span>
          <span v-else-if="item.name=='ProductBatch'">
            <el-badge v-if="testValue>0" :value="testValue" class="item">
              <span>{{ item.children[0].meta.title}}</span>
            </el-badge>
              <span v-else>{{ item.children[0].meta.title}}</span>
          </span>
              <!-- <span v-else>{{ item.children[0].meta.title }}</span> -->
          <span v-else>{{ item.children[0].meta.title }}</span>
            <!-- <span v-else>{{ item.children[0].meta.title }}</span> -->
            <!-- <span v-if="item.children[0].meta.showCountType == 'ADMIN'" class="tips">{{adminCount}}</span> -->
            <!-- <span v-if="item.children[0].meta.showCountType == 'PRODUCT'" class="tips">{{productCount}}</span> -->
            <!-- <span v-if="item.children[0].meta.showCountType == 'RECHARGE'" class="tips">{{rechargeCount}}</span> -->
          </div>
        </el-menu-item>
      </router-link>

      <!-- 具有下拉的菜单 -->
      <el-submenu v-else :index="item.name || item.path" :key="item.name">
        <!-- 最外层菜单名称 如：权限 -->
        <template slot="title">
          <svg-icon
            v-if="item.meta && item.meta.icon"
            :icon-class="item.meta.icon"
          ></svg-icon>
          <span v-if="item.meta && item.meta.title" slot="title">{{
            item.meta.title
          }}</span>
        </template>
        <!-- 如：权限子路由 -->
        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item
            :is-nest="true"
            class="nest-menu"
            v-if="child.children && child.children.length > 0"
            :routes="[child]"
            :key="child.path"
          ></sidebar-item>

          <router-link
            v-else
            :to="item.path + '/' + child.path"
            :key="child.name"
          >
            <el-menu-item :index="item.path + '/' + child.path">
              <svg-icon
                v-if="child.meta && child.meta.icon"
                :icon-class="child.meta.icon"
              ></svg-icon>
              <div
                v-if="child.meta && child.meta.title"
                slot="title"
                style="display: inline"
              >
              <span>{{child.meta.title}} </span>
                <!-- <span v-if="child.meta.showCountType == 'ADMIN'" class="tips">{{adminCount}}</span> -->
                <!-- <span v-if="child.meta.showCountType == 'PRODUCT'" class="tips">{{productCount}}</span> -->
                <!-- <span v-if="child.meta.showCountType == 'RECHARGE'" class="tips">{{rechargeCount}}</span> -->
              </div>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
// import {waitHandleWork} from '@/api/product';
export default {
  name: "SidebarItem",
  inject:['reaciveBadgeValue','reaciveTestValue','reacivePlatValue'],
  props: {
    routes: {
      type: Array,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // adminCount: 0,
      // productCount:0,
      // rechargeCount:0,
      // timeId:'',
    };
  },
  computed:{
    badgeValue(){
      return this.reaciveBadgeValue()
    },
    testValue(){
      return this.reaciveTestValue()
    },
    platValue(){
      return this.reacivePlatValue()
    }
  },
  // watch:{
  //   'badgeValue':(val)=>{
  //     console.log(val,'change');
  //   }
  // },
  created() {
    // console.log(this.routes,'layout');
    // console.log(this.platValue);
  },
  mounted(){
    // console.log(this.reacivePlatValue());
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter((item) => {
        return !item.hidden;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.tips {
  color: rgba(255, 60, 0, 0.876);
  margin-left: 10px;
}
.item{
  margin-top: -5px;
}
.title{
  width: 176px;
  height: 70px;
  font-size: 30px;
  color: white;
  text-align: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue